import React, { useEffect, useState } from "react";
import CampaignService from "../../service/CampaignService";
import { useNavigate } from "react-router";

const WebDirectReservation = ({ kind, customerNo, code, customerInfo }) => {
  const [progress, setProgress] = useState(0);
  const navgation = useNavigate();

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prev) => (prev < 100 ? prev + 1 : 100));
    }, 30); // 30ms마다 프로그레스 바를 1%씩 증가
    return () => clearInterval(timer);
  }, []);

  const updateDBAndRedirect = async () => {
    try {
      // DB 상태 업데이트
      const result = await CampaignService.updateWebStatus(kind, customerNo, code);
      if (result) {
        console.log("customerInfo", customerInfo);

        if (customerInfo?.기획전사용여부) {
          const url = customerInfo?.기획전주소 || "";
          if (url === "") {
            alert("기획전 주소가 없습니다.");
          } else {
            window.location.href = url;
          }
        } else {
          // navgation("/ExternalProductList");
          navgation("/ExternalProductList", { state: { customerInfo,customerNo } });
        }
      } else {
        alert("DB 업데이트에 실패했습니다.");
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      updateDBAndRedirect(); // DB 상태를 업데이트하고 페이지 이동
    }, 2000);
    return () => clearTimeout(timer);
  }, [customerInfo]);

  //   useEffect(() => {
  //     const timer = setTimeout(() => {
  //       const url = customerInfo?.기획전주소 || "";

  //       if (url === "") {
  //         alert("기획전 주소가 없습니다.");
  //       } else {
  //         window.location.href = url;
  //       }
  //     }, 2000);
  //     return () => clearTimeout(timer);
  //   }, [customerInfo]);

  return (
    <div className="sm:min-w-screen md:max-w-[375px] mx-auto min-h-screen  relative overflow-hidden  bg-white ">
      <div className="absolute top-0 left-0 bg-[#3e9ff9] " style={{ width: `${progress}%`, height: "4px" }} />

      <div className="w-full absolute mx-auto top-[335px] text-base font-bold text-center text-black">기획전 페이지로 이동중입니다..</div>
      <p className="w-full absolute left-0 top-[582px] text-sm font-bold text-center text-[#717171]">
        <span className="w-full  text-sm font-bold text-center text-[#717171]">추가 문의 사항이 있으시면</span>
        <br />
        <span className="w-full text-sm font-bold text-center text-[#717171]">상담을 신청해 주세요</span>
      </p>
      <div className="flex flex-col justify-start items-center w-full absolute left-0 top-[148px] gap-3 py-[25px]">
        {/* <img src="/assets/img/logo1.png" className="flex-grow-0 flex-shrink-0 max-w-[150px]h-[47px] object-cover" /> */}
        <img src={customerInfo?.로고경로 || ""} className="flex-grow-0 flex-shrink-0 max-w-[150px] h-[47px] object-fill" />
      </div>
    </div>
  );
};

export default WebDirectReservation;
